import MenuToggle from './MenuToggle';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import mapProps from 'recompose/mapProps';
import { withModel } from '../../../data-providers/model';
import { isNavOpen, updateNavOpenState } from '../duck';

const enhance = compose(
  withModel,
  connect(state => ({
    isNavOpen: isNavOpen(state),
  })),
  withHandlers({
    handleClick: props => () => {
      props.dispatch(updateNavOpenState(!props.isNavOpen));
    },
  }),
  mapProps(props => ({
    isNavOpen: props.isNavOpen,
    handleClick: props.handleClick,
    label: props.model.prismicNavigationModel.menuLabel,
  }))
);

export default enhance(MenuToggle);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Header/MenuToggle/index.js